import React from "react";

// COMPONENTS
import AppNavBar from "../NavBar/AppNavBar";

// STYLES
import "./WithNavLayout.scss";

interface IWithNavLayoutProps {
    className?: string;
    children: React.ReactNode;
}

const WithNavLayout: React.FC<IWithNavLayoutProps> = ({
    className = "",
    children,
}) => {
    return (
        <div className={`WithNavLayout ${className}`}>
            <AppNavBar />
            <div className="WithNavLayout__content">{children}</div>
        </div>
    );
};

export default WithNavLayout;
